import React from "react";
import { Col, Row } from "react-bootstrap";
import { Link } from "react-router-dom";
import { HeaderEnum } from "./constant";
const IpoContent = (props) => {
    const hidenavTab = () => {
        props.setShowNav(() => !props.showNav);
    };
    return (React.createElement(React.Fragment, null,
        React.createElement(Row, { className: "mx-0 header-link-section" },
            React.createElement(Col, { lg: 12, className: "grid-3" },
                React.createElement("ul", { className: "header-link-content" },
                    React.createElement(Link, { to: HeaderEnum.IPO, onClick: () => {
                            hidenavTab();
                        } },
                        React.createElement("li", { className: "headermainheading" }, "IPO")),
                    React.createElement("li", null,
                        React.createElement(Link, { to: HeaderEnum.IPO_LIVES, onClick: () => {
                                hidenavTab();
                            } }, "Live IPOs")),
                    React.createElement("li", null,
                        React.createElement(Link, { to: HeaderEnum.IPO_TOBE_ANNOUNCED, onClick: () => {
                                hidenavTab();
                            } }, "To be Announced")),
                    React.createElement("li", null,
                        React.createElement(Link, { to: HeaderEnum.IPO_LISTING_PERFORMANCE, onClick: () => {
                                hidenavTab();
                            } }, "Listing Performance of Past IPOs"))),
                React.createElement("ul", { className: "header-link-content" },
                    React.createElement(Link, { to: HeaderEnum.NCD, onClick: () => {
                            hidenavTab();
                        } },
                        " ",
                        React.createElement("li", { className: "headermainheading" }, "NCD IPO")),
                    React.createElement("li", null,
                        React.createElement(Link, { to: HeaderEnum.NCD_IPO_LIVES, onClick: () => {
                                hidenavTab();
                            } }, "Live NCD IPOs")),
                    React.createElement("li", null,
                        React.createElement(Link, { to: HeaderEnum.NCD_IPO_UPCOMING, onClick: () => {
                                hidenavTab();
                            } }, "Upcoming NCD IPOs"))),
                React.createElement("ul", { className: "header-link-content" },
                    React.createElement(Link, { to: HeaderEnum.NFO, onClick: () => {
                            hidenavTab();
                        } },
                        React.createElement("li", { className: "headermainheading" }, "NFO")),
                    React.createElement("li", null,
                        React.createElement(Link, { to: HeaderEnum.NFO_LIVES, onClick: () => {
                                hidenavTab();
                            } }, "Live NFOs")),
                    React.createElement("li", null,
                        React.createElement(Link, { to: HeaderEnum.NFO_UPCOMING, onClick: () => {
                                hidenavTab();
                            } }, "Upcoming NFOs")),
                    React.createElement("li", null,
                        React.createElement(Link, { to: HeaderEnum.NFO_LISTING_PERFORMANCE, onClick: () => {
                                hidenavTab();
                            } }, "Listing Performance of Past NFOs")))))));
};
export default IpoContent;
